import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/giovambattistafazioli/Lavori/Github/react-toggle/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "upgrade-guide"
    }}>{`Upgrade Guide`}</h1>
    <h2 {...{
      "id": "upgrade-to-20-from-1x"
    }}>{`Upgrade to 2.0 from 1.x`}</h2>
    <p>{`This version is not fully compatible with the previous 1.x versions. Anyway, you may update your code easly`}</p>
    <h2 {...{
      "id": "labels"
    }}>{`Labels`}</h2>
    <p>{`First of all, we've removed the props for the labels. You can upgrade your code by following`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// previous v1.x
<Toggle label="Left label" />

// Left label from v2.x
<label htmlFor="toggle-a">
  Click me
  <Toggle name="toggle-a" />
</label>

// Right label from v2.x
<label htmlFor="toggle-b">
  <Toggle name="toggle-b" />
  Click me
</label>
`}</code></pre>
    <h2 {...{
      "id": "events"
    }}>{`Events`}</h2>
    <p>{`The previous `}<inlineCode parentName="p">{`onChange`}</inlineCode>{` event become `}<inlineCode parentName="p">{`onToggle`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// previous v1.x
<Toggle name="toggle-c" onChange={(checked, evt) => console.log(e.target.checked)} />

// from v2.x
<Toggle name="toggle-c" onToggle={e => console.log(e.target.checked)} />
`}</code></pre>
    <p>{`The new `}<inlineCode parentName="p">{`onToggle`}</inlineCode>{` event, has got only one param, I mean, the standard `}<inlineCode parentName="p">{`event`}</inlineCode>{` object.
In fact, you will be able to get all information about the toggle by using `}<inlineCode parentName="p">{`e.target`}</inlineCode>{` as shown above.`}</p>
    <p>{`In addition, you may use the new `}<inlineCode parentName="p">{`onRight`}</inlineCode>{` and `}<inlineCode parentName="p">{`onLeft`}</inlineCode>{` events. They are trigged when the toggle is switched from the left to the right and vice versa. In short, when it's `}<strong parentName="p">{`on`}</strong>{` (usually) and `}<strong parentName="p">{`off`}</strong>{` (usually).`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// from left to the right "on"
<Toggle name="toggle-c" onRight={e => console.log(e.target.name)} />

// from right to the left "off"
<Toggle name="toggle-c" onLeft={e => console.log(e.target.name)} />
`}</code></pre>
    <h2 {...{
      "id": "mode-prop"
    }}>{`Mode prop`}</h2>
    <p>{`Also the prop `}<inlineCode parentName="p">{`mode`}</inlineCode>{` is no longer available. This because in the previous version the `}<inlineCode parentName="p">{`mode="switch"`}</inlineCode>{` was keeping the "on" and "off" appearance colours the same. Now, you can do the same by using the new props. See the  `}<a parentName="p" {...{
        "href": "/react-toggle/theming"
      }}>{`Theming`}</a>{` section for more details.`}</p>
    <h2 {...{
      "id": "theme-prop"
    }}>{`Theme prop`}</h2>
    <p>{`We have also removed the `}<inlineCode parentName="p">{`theme`}</inlineCode>{` prop. Now, you'll be able to create any toggle theme by using the new props for the appearance and the theme provider. See the `}<a parentName="p" {...{
        "href": "/react-toggle/theming"
      }}>{`Theming`}</a>{` section for more details.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      